
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/fine-stagione-sciistica",
      function () {
        return require("private-next-pages/[region]/fine-stagione-sciistica.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/fine-stagione-sciistica"])
      });
    }
  